var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"height":"100%","flat":""}},[_c('v-container',{attrs:{"fill-height":""}},[_c(_setup.UserDepartmentTable,{attrs:{"user-id":_vm.userId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }